export class TenantBranding {
  // Default colors match theme.scss variables
  public static readonly DEFAULT_PRIMARY_AND_SECONDARY = '#7a57cd';
  public static readonly DEFAULT_SECONDARY = '#4e4e5f';
  public static readonly DEFAULT = new TenantBranding(
    TenantBranding.DEFAULT_PRIMARY_AND_SECONDARY,
    TenantBranding.DEFAULT_SECONDARY,
    TenantBranding.DEFAULT_PRIMARY_AND_SECONDARY
  );
  constructor(
    public primaryColor: string,
    public secondaryColor: string,
    public accentColor: string,
    public logoUrl?: string
  ) {}

  static parse(obj: Partial<TenantBranding>): TenantBranding {
    return obj
      ? new TenantBranding(
          obj.primaryColor || TenantBranding.DEFAULT_PRIMARY_AND_SECONDARY,
          obj.secondaryColor || TenantBranding.DEFAULT_SECONDARY,
          obj.accentColor || TenantBranding.DEFAULT_PRIMARY_AND_SECONDARY,
          obj.logoUrl
        )
      : TenantBranding.DEFAULT;
  }

  /**
   * Apply branding colors to the document root as CSS custom properties
   */
  applyToDocument(): void {
    if (this.primaryColor) {
      document.documentElement.style.setProperty('--brand-primary', this.primaryColor);
      document.documentElement.style.setProperty('--mat-theme-primary', this.primaryColor);
    }
    if (this.secondaryColor) {
      document.documentElement.style.setProperty('--brand-secondary', this.secondaryColor);
    }
    if (this.accentColor) {
      document.documentElement.style.setProperty('--brand-accent', this.accentColor);
      document.documentElement.style.setProperty('--mat-theme-secondary', this.accentColor);
    }
  }
}
